module.exports = __webpack_public_path__ + "img/2AA.86691f60.jpg";